import axios from 'axios';

import { AvailabilitySlot, InvestorAvailability, NewAvailabilitySlotDto } from '../interfaces/availability.interface';

class InvestorAvailabilityService {
  async getInvestorAvailability(): Promise<InvestorAvailability> {
    const response = await axios.get<InvestorAvailability>('investor-availability');
    return response.data as InvestorAvailability;
  }

  async updateShowingDuration(investorAvailabilityId: string, durationInMinutes: number): Promise<void> {
    await axios.patch<InvestorAvailability>(`investor-availability/${investorAvailabilityId}/showing-duration`, {
      durationInMinutes,
    });
  }

  async createAvailabilitySlot(availability: NewAvailabilitySlotDto): Promise<AvailabilitySlot> {
    const response = await axios.post<AvailabilitySlot>('availability-slot', availability);
    return response.data as AvailabilitySlot;
  }

  async updateAvailabilitySlot(availability: AvailabilitySlot): Promise<AvailabilitySlot> {
    const response = await axios.patch<AvailabilitySlot>('availability-slot', availability);
    return response.data as AvailabilitySlot;
  }

  async deleteAvailabilitySlots(ids: string[]): Promise<void> {
    await axios.delete('availability-slot', { data: ids });
  }
}

export default new InvestorAvailabilityService();
